import { render } from "./CardDescription.vue?vue&type=template&id=775500d1&ts=true"
import script from "./CardDescription.vue?vue&type=script&lang=ts"
export * from "./CardDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__